export default "__VITE_ASSET__Bypd96J0__"